import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import { putData } from "../../../utils/api";
import { useNavigate } from "react-router";
import Header from "../../Header/Header";
import { useParams } from "react-router-dom";
library.add(fas);

const EditOffCanvance = (props) => {
  const navigate = useNavigate();

  const { id } = useParams();
  const { postData, getData, IMG_URL } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });
  const [existingCommonEjs, setExistingCommonEjs] = useState(null);

  const GetEditData = async () => {
    const response = await getData(`/admin/setting/app-setup/${id}`);
    reset(response?.data);
    setExistingCommonEjs(response?.data?.common_ejs); // 👈 IMPORTANT
  };
  useEffect(() => {
    GetEditData();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    getValues,
    watch,
    setValue,
  } = useForm();

  const imageFile = watch("logo");
  const imageFileQR = watch("qr_image");
  const homePosterFile = watch("home_poster_image");
  const commonEjsFile = watch("common_ejs");
  // const existingCommonEjs = getValues("common_ejs");
  // const navigate = useNavigate();
  const onSubmit = async (data) => {
    try {
      const finalData = new FormData();
      if (data?.website_name) {
        finalData.append("website_name", data?.website_name);
      }
      if (data?.business_hours) {
        finalData.append("business_hours", data?.business_hours);
      }
      if (data?.contact_no) {
        finalData.append("contact_no", data?.contact_no);
      }
      if (data?.alt_contact_no) {
        finalData.append("alt_contact_no", data?.alt_contact_no);
      }
      if (data?.email) {
        finalData.append("email", data?.email);
      }
      if (data?.address) {
        finalData.append("address", data?.address);
      }
      if (data?.second_address) {
        finalData.append("second_address", data?.second_address);
      }
      if (data?.cancel_period) {
        finalData.append("cancel_period", data.cancel_period);
      }
      if (data?.shipping_charges) {
        finalData.append("shipping_charges", data?.shipping_charges);
      }
      if (data?.tax_charges) {
        finalData.append("tax_charges", data?.tax_charges);
      }
      if (data?.minimum_order) {
        finalData.append("minimum_order", data?.minimum_order);
      }
      if (data?.lat) {
        finalData.append("lat", data?.lat);
      }
      if (data?.long) {
        finalData.append("long", data?.long);
      }
      if (data?.return_charges) {
        finalData.append("return_charges", data.return_charges);
      }
      if (data?.return_period) {
        finalData.append("return_period", data.return_period);
      }
      // only a newly selected file is sent (an unchanged logo is the saved path string)
      if (data?.logo?.[0] instanceof File) {
        finalData.append("logo", data.logo[0]);
      }

      // only a newly selected file is sent (an unchanged poster is the saved path string)
      if (data?.home_poster_image?.[0] instanceof File) {
        finalData.append("home_poster_image", data.home_poster_image[0]);
      }

      finalData.append("logo_alt_tag", data?.logo_alt_tag?.trim() || "");
      // QR upload field is currently commented out in this form; only send its alt when the field is rendered
      if (data?.qr_image_alt_tag !== undefined) {
        finalData.append("qr_image_alt_tag", data.qr_image_alt_tag?.trim() || "");
      }

      if (data?.qr_image?.[0]) {
        finalData.append("qr_image", data.qr_image[0]);
      }
      if (data?.common_ejs?.[0]) {
        finalData.append("common_ejs", data.common_ejs[0]);
      }

      if (data?.home_page_timer) {
        finalData.append("home_page_timer", data?.home_page_timer);
      }

      if (data?.online_number) {
        finalData.append("online_number", data?.online_number);
      }
      if (data?.corporate_number) {
        finalData.append("corporate_number", data?.corporate_number);
      }
      if (data?.store_number) {
        finalData.append("store_number", data?.store_number);
      }

      //  finalData.append("customer_limit", data?.customer_limit);
      // finalData.append("refer_to_percentage", data?.refer_to_percentage);
      if (data?.low_stock_day) {
        finalData.append("low_stock_day", data.low_stock_day);
      }
      if (data?.whatsapp_number) {
        finalData.append("whatsapp_number", data.whatsapp_number);
      }
      if (data?.razorpay_api_key) {
        finalData.append("razorpay_api_key", data.razorpay_api_key.trim());
      }
      finalData.append("meta_title", data?.meta_title);
      finalData.append("meta_description", data?.meta_description);
      finalData.append("keywords", data?.keywords);
      finalData.append("schema_data", data?.schema_data);
      const response = await putData(
        `/admin/setting/app-setup/${id}`,
        finalData,
      );

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response?.code, message: response?.errors });
      }
      setTimeout(() => {
        setShowModal(0);
        navigate("/settings/app-setup");
        // props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const [imagePreview, setImagePreview] = useState(null); // State to store image preview

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <>
      <Header title={"Edit App Setup"} link={"#"} />
      <section className="Create">
        <div className="back_btn_holder">
          <div onClick={() => navigate(`/settings/app-setup`)}>
            <FontAwesomeIcon className="back-btn" icon={faAngleLeft} />
            Back
          </div>
        </div>

        {/* <Form onSubmit={() => handleSubmit(onSubmit)} role="form"> */}
        <Form onSubmit={handleSubmit(onSubmit)}>
          {/* <Form onSubmit={handleSubmit(onSubmit)} role="form"> */}
          <Row className="">
            <Col md={6}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Form.Group>
                    <Form.Label>Website Name</Form.Label>

                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="website_name"
                        placeholder="The Moon"
                        className={classNames("", {
                          "is-invalid": errors?.website_name,
                        })}
                        {...register("website_name", {
                          required: "Website name is required",
                          maxLength: {
                            value: 200,
                            message: "Data must be 200 characters or less",
                          },
                          pattern: {
                            value: /^[A-Za-z\s]+$/,
                            message: "Only alphabets are allowed",
                          },
                        })}
                      />
                    </InputGroup>
                    {errors.website_name && (
                      <span className="text-danger">
                        {errors.website_name.message}
                      </span>
                    )}
                  </Form.Group>
                </Row>
              </div>
            </Col>

            <Col md={6}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Form.Group>
                    <Form.Label>Business Hours</Form.Label>

                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="business_hours"
                        placeholder="The Moon"
                        className={classNames("", {
                          "is-invalid": errors?.business_hours,
                        })}
                        {...register("business_hours", {
                          required: "Business hours is required",
                          maxLength: {
                            value: 200,
                            message: "Data must be 200 characters or less",
                          },
                          // pattern: {
                          //   value: /^[A-Za-z\s]+$/,
                          //   message: "Only alphabets are allowed",
                          // },
                        })}
                      />
                    </InputGroup>
                    {errors.business_hours && (
                      <span className="text-danger">
                        {errors.business_hours.message}
                      </span>
                    )}
                  </Form.Group>
                </Row>
              </div>
            </Col>

            {/* <Col md={6}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Form.Group>
                    <Form.Label>Latitude</Form.Label>

                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="lat"
                        placeholder="lat"
                        className={classNames("", {
                          "is-invalid": errors?.lat,
                        })}
                        {...register("lat", {
                          required: "lat Is Required",
                          validate: (value) =>
                            value.length <= 200 ||
                            "Data must be 200 characters or less",
                        })}
                      />
                    </InputGroup>
                    {errors.lat && (
                      <span className="text-danger">{errors.lat.message}</span>
                    )}
                  </Form.Group>
                </Row>
              </div>
            </Col> */}

            {/* <Col md={6}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Form.Group>
                    <Form.Label>Longitude</Form.Label>

                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="long"
                        placeholder="long"
                        className={classNames("", {
                          "is-invalid": errors?.long,
                        })}
                        {...register("long", {
                          required: "long Is Required",
                          validate: (value) =>
                            value.length <= 200 ||
                            "Data must be 200 characters or less",
                        })}
                      />
                    </InputGroup>
                    {errors.long && (
                      <span className="text-danger">{errors.long.message}</span>
                    )}
                  </Form.Group>
                </Row>
              </div>
            </Col> */}

            <Col md={6}>
              <div className="main-form-section mt-3">
                <Form.Group>
                  <div className="">
                    <Form.Label>Contact No</Form.Label>
                  </div>
                  <InputGroup>
                    <Form.Control
                      type="text"
                      name={`contact_no`}
                      placeholder="Mobile Number"
                      className={classNames("", {
                        "is-invalid": errors?.contact_no,
                      })}
                      {...register(`contact_no`, {
                        required: "Mobile Number is required",
                        validate: (value) =>
                          value.length === 10 ||
                          " Contact number must be exactly 10 digits",
                      })}
                      onKeyDown={(e) => {
                        const { key } = e;
                        const value = e.target.value;
                        if (key === "ArrowLeft" || key === "ArrowRight") {
                          return;
                        }
                        if (
                          !/[0-9]/.test(key) &&
                          key !== "Backspace" &&
                          key !== "Tab"
                        ) {
                          e.preventDefault();
                        }
                        // if (
                        //   value?.length >= 10 &&
                        //   key !== "Backspace" &&
                        //   key !== "Tab"
                        // ) {
                        //   e.preventDefault();
                        // }
                      }}
                    />
                  </InputGroup>
                  {errors.contact_no && (
                    <span className="text-danger">
                      {errors.contact_no.message}
                    </span>
                  )}
                </Form.Group>
              </div>
            </Col>

            <Col md={6}>
              <div className="main-form-section mt-3">
                <Form.Group>
                  <div className="">
                    <Form.Label>Online Number</Form.Label>
                  </div>
                  <InputGroup>
                    <Form.Control
                      type="text"
                      name={`online_number`}
                      placeholder="Online Number"
                      className={classNames("", {
                        "is-invalid": errors?.online_number,
                      })}
                      {...register(`online_number`, {
                        required: "Online Number is required",
                        validate: (value) =>
                          value.length === 10 ||
                          " Online number must be exactly 10 digits",
                      })}
                      onKeyDown={(e) => {
                        const { key } = e;
                        const value = e.target.value;
                        if (key === "ArrowLeft" || key === "ArrowRight") {
                          return;
                        }
                        if (
                          !/[0-9]/.test(key) &&
                          key !== "Backspace" &&
                          key !== "Tab"
                        ) {
                          e.preventDefault();
                        }
                        // if (
                        //   value?.length >= 10 &&
                        //   key !== "Backspace" &&
                        //   key !== "Tab"
                        // ) {
                        //   e.preventDefault();
                        // }
                      }}
                    />
                  </InputGroup>
                  {errors.online_number && (
                    <span className="text-danger">
                      {errors.online_number.message}
                    </span>
                  )}
                </Form.Group>
              </div>
            </Col>

            <Col md={6}>
              <div className="main-form-section mt-3">
                <Form.Group>
                  <div className="">
                    <Form.Label>Corporate Number</Form.Label>
                  </div>
                  <InputGroup>
                    <Form.Control
                      type="text"
                      name={`corporate_number`}
                      placeholder="Corporate Number"
                      className={classNames("", {
                        "is-invalid": errors?.corporate_number,
                      })}
                      {...register(`corporate_number`, {
                        required: "Corporate Number is required",
                        validate: (value) =>
                          value.length === 10 ||
                          " Corporate number must be exactly 10 digits",
                      })}
                      onKeyDown={(e) => {
                        const { key } = e;
                        const value = e.target.value;
                        if (key === "ArrowLeft" || key === "ArrowRight") {
                          return;
                        }
                        if (
                          !/[0-9]/.test(key) &&
                          key !== "Backspace" &&
                          key !== "Tab"
                        ) {
                          e.preventDefault();
                        }
                        // if (
                        //   value?.length >= 10 &&
                        //   key !== "Backspace" &&
                        //   key !== "Tab"
                        // ) {
                        //   e.preventDefault();
                        // }
                      }}
                    />
                  </InputGroup>
                  {errors.corporate_number && (
                    <span className="text-danger">
                      {errors.corporate_number.message}
                    </span>
                  )}
                </Form.Group>
              </div>
            </Col>

            <Col md={6}>
              <div className="main-form-section mt-3">
                <Form.Group>
                  <div className="">
                    <Form.Label>Store Number</Form.Label>
                  </div>
                  <InputGroup>
                    <Form.Control
                      type="text"
                      name={`store_number`}
                      placeholder="Store Number"
                      className={classNames("", {
                        "is-invalid": errors?.store_number,
                      })}
                      {...register(`store_number`, {
                        required: "Store Number is required",
                        validate: (value) =>
                          value.length === 10 ||
                          " Store number must be exactly 10 digits",
                      })}
                      onKeyDown={(e) => {
                        const { key } = e;
                        const value = e.target.value;
                        if (key === "ArrowLeft" || key === "ArrowRight") {
                          return;
                        }
                        if (
                          !/[0-9]/.test(key) &&
                          key !== "Backspace" &&
                          key !== "Tab"
                        ) {
                          e.preventDefault();
                        }
                        // if (
                        //   value?.length >= 10 &&
                        //   key !== "Backspace" &&
                        //   key !== "Tab"
                        // ) {
                        //   e.preventDefault();
                        // }
                      }}
                    />
                  </InputGroup>
                  {errors.store_number && (
                    <span className="text-danger">
                      {errors.store_number.message}
                    </span>
                  )}
                </Form.Group>
              </div>
            </Col>

            <Col md={6}>
              <div className="main-form-section mt-3">
                <Form.Group>
                  <div className="">
                    <Form.Label>WhatsApp Number</Form.Label>
                  </div>
                  <InputGroup>
                    <Form.Control
                      type="text"
                      name={`whatsapp_number`}
                      placeholder="WhatsApp Number"
                      className={classNames("", {
                        "is-invalid": errors?.whatsapp_number,
                      })}
                      {...register(`whatsapp_number`, {
                        required: "WhatsApp Number is required",
                        validate: (value) =>
                          value.length === 10 ||
                          " WhatsApp number must be exactly 10 digits",
                      })}
                      onKeyDown={(e) => {
                        const { key } = e;
                        const value = e.target.value;
                        if (key === "ArrowLeft" || key === "ArrowRight") {
                          return;
                        }
                        if (
                          !/[0-9]/.test(key) &&
                          key !== "Backspace" &&
                          key !== "Tab"
                        ) {
                          e.preventDefault();
                        }
                        // if (
                        //   value?.length >= 10 &&
                        //   key !== "Backspace" &&
                        //   key !== "Tab"
                        // ) {
                        //   e.preventDefault();
                        // }
                      }}
                    />
                  </InputGroup>
                  {errors.whatsapp_number && (
                    <span className="text-danger">
                      {errors.whatsapp_number.message}
                    </span>
                  )}
                </Form.Group>
              </div>
            </Col>

            <Col md={6}>
              <div className="main-form-section mt-3">
                <Form.Group>
                  <div className="">
                    <Form.Label>Razorpay API Key</Form.Label>
                  </div>
                  <InputGroup>
                    <Form.Control
                      type="text"
                      name="razorpay_api_key"
                      placeholder="rzp_live_xxxxxxxxxxxxxx"
                      autoComplete="off"
                      className={classNames("", {
                        "is-invalid": errors?.razorpay_api_key,
                      })}
                      {...register("razorpay_api_key", {
                        required: "Razorpay API Key is required",
                        validate: (value) =>
                          /^rzp_(test|live)_[A-Za-z0-9]+$/.test(value?.trim()) ||
                          "Enter the Razorpay Key Id (starts with rzp_test_ or rzp_live_). Never enter the secret key here",
                      })}
                    />
                  </InputGroup>
                  {errors.razorpay_api_key && (
                    <span className="text-danger">
                      {errors.razorpay_api_key.message}
                    </span>
                  )}
                </Form.Group>
              </div>
            </Col>

            {/* <Col md={6}>
              <div className="main-form-section mt-3">
                <Form.Group>
                  <div className="">
                    <Form.Label>Alternate Contact No</Form.Label>
                  </div>
                  <InputGroup>
                    <Form.Control
                      type="text"
                      name={`alt_contact_no`}
                      placeholder="Mobile Number"
                      className={classNames("", {
                        "is-invalid": errors?.alt_contact_no,
                      })}
                      {...register(`alt_contact_no`, {
                        required: "Mobile Number is required",
                        validate: (value) =>
                          value.length === 10 ||
                          " Contact number must be exactly 10 digits",
                      })}
                      onKeyDown={(e) => {
                        const { key } = e;
                        const value = e.target.value;
                        if (key === "ArrowLeft" || key === "ArrowRight") {
                          return;
                        }
                        if (
                          !/[0-9]/.test(key) &&
                          key !== "Backspace" &&
                          key !== "Tab"
                        ) {
                          e.preventDefault();
                        }
                        // if (
                        //   value?.length >= 10 &&
                        //   key !== "Backspace" &&
                        //   key !== "Tab"
                        // ) {
                        //   e.preventDefault();
                        // }
                      }}
                    />
                  </InputGroup>
                  {errors.alt_contact_no && (
                    <span className="text-danger">
                      {errors.alt_contact_no.message}
                    </span>
                  )}
                </Form.Group>
              </div>
            </Col> */}

            {/* <Col md={6}>
              <div className="main-form-section mt-3">
                <Form.Group>
                  <div className="">
                    <Form.Label>Email</Form.Label>
                  </div>
                  <InputGroup>
                    <Form.Control
                      type="text"
                      name="email"
                      placeholder="Email"
                      className={classNames("", {
                        "is-invalid": errors?.email,
                      })}
                      {...register("email", {
                        required: "Email is required",
                        pattern: {
                          value:
                            /^([A-Za-z0-9_\-\.])+\@(?!(?:[A-Za-z0-9_\-\.]+\.)?([A-Za-z0-9_\-\.]+)\.\2)([A-Za-z0-9_\-\.]+\.)+([A-Za-z]{2,4})$/,
                          message: "Invalid Email address",
                        },
                        validate: (value) => {
                          // Extract the domain and TLD
                          const domainPattern =
                            /^([A-Za-z0-9_\-\.])+\@(?!(?:[A-Za-z0-9_\-\.]+\.)?([A-Za-z0-9_\-\.]+)\.\2)([A-Za-z0-9_\-\.]+\.)+([A-Za-z]{2,4})$/;
                          const match = value.match(domainPattern);
                          if (match) {
                            const domainParts = match[1].split(".");
                            const tld = match[2];

                            // Ensure the domain and TLD are not the same
                            if (domainParts[domainParts.length - 1] === tld) {
                              return "Domain and top-level domain must be different";
                            }
                          }
                          return true;
                        },
                      })}
                      onKeyDown={(e) => {
                        if (e.key === " ") {
                          e.preventDefault();
                        }
                      }}
                    />
                  </InputGroup>
                  {errors.email && (
                    <span className="text-danger">{errors.email.message}</span>
                  )}
                </Form.Group>
              </div>
            </Col> */}

            <Col md={6}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Form.Label>Shipping Charges</Form.Label>
                  <Form.Group>
                    <Form.Control
                      type="text"
                      name={`shipping_charges`}
                      placeholder="Shipping Charges"
                      className={classNames("", {
                        "is-invalid": errors?.shipping_charges, // Adjusted error checking
                      })}
                      // {...register(`shipping_charges`, {
                      //   required: {
                      //     message: "Return Charges required ",
                      //     validate: (value) =>
                      //       value.length <= 200 ||
                      //       "Data must be 200 characters or less", // Custom required message
                      //   },
                      // })}
                      {...register("shipping_charges", {
                        required: "Shipping Charges required",
                        validate: (value) =>
                          value.length <= 200 ||
                          "Data must be 200 characters or less",
                      })}
                      onKeyDown={(e) => {
                        // Allow backspace, left arrow, right arrow, and digits
                        if (
                          !(
                            e.key === "Backspace" ||
                            e.key === "ArrowLeft" ||
                            e.key === "ArrowRight" ||
                            (e.key >= "0" && e.key <= "9")
                          )
                        ) {
                          e.preventDefault(); // Prevent default action for non-allowed keys
                        }
                      }}
                    />
                    {errors.shipping_charges && (
                      <span className="text-danger">
                        {errors.shipping_charges.message}
                      </span>
                    )}
                  </Form.Group>
                </Row>
              </div>
            </Col>

            <Col md={6}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Form.Label>Tax Charges(percentage)</Form.Label>
                  <Form.Group>
                    <Form.Control
                      type="text"
                      name={`tax_charges`}
                      placeholder="Tax Charges"
                      className={classNames("", {
                        "is-invalid": errors?.tax_charges, // Adjusted error checking
                      })}
                      // {...register(`tax_charges`, {
                      //   required: {
                      //     message: "Return Charges required ",
                      //     validate: (value) =>
                      //       value.length <= 200 ||
                      //       "Data must be 200 characters or less", // Custom required message
                      //   },
                      // })}
                      {...register("tax_charges", {
                        required: "Tax Charges required",
                        maxLength: {
                          value: 3,
                          message: "Tax percentage cannot exceed 3 digits",
                        },
                      })}
                      onKeyDown={(e) => {
                        // Allow backspace, left arrow, right arrow, and digits
                        if (
                          !(
                            e.key === "Backspace" ||
                            e.key === "ArrowLeft" ||
                            e.key === "ArrowRight" ||
                            (e.key >= "0" && e.key <= "9")
                          )
                        ) {
                          e.preventDefault(); // Prevent default action for non-allowed keys
                        }
                      }}
                    />
                    {errors.tax_charges && (
                      <span className="text-danger">
                        {errors.tax_charges.message}
                      </span>
                    )}
                  </Form.Group>
                </Row>
              </div>
            </Col>

            {/* <Col md={6}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Form.Label>Minimum Order(price)</Form.Label>
                  <Form.Group>
                    <Form.Control
                      type="text"
                      name={`minimum_order`}
                      placeholder="Returnable Days"
                      className={classNames("", {
                        "is-invalid": errors?.minimum_order, // Adjusted error checking
                      })}
                      {...register(`minimum_order`, {
                        required: {
                          message: "days are required ", // Custom required message
                        },
                      })}
                      onKeyDown={(e) => {
                        // Allow backspace, left arrow, right arrow, and digits
                        if (
                          !(
                            e.key === "Backspace" ||
                            e.key === "ArrowLeft" ||
                            e.key === "ArrowRight" ||
                            (e.key >= "0" && e.key <= "9")
                          )
                        ) {
                          e.preventDefault(); // Prevent default action for non-allowed keys
                        }
                      }}
                    />
                    {errors.minimum_order && (
                      <span className="text-danger">
                        {errors.minimum_order.message}
                      </span>
                    )}
                  </Form.Group>
                </Row>
              </div>
            </Col> */}

            <Col md={6}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Form.Label>Home Banner Timer (Seconds)</Form.Label>
                  <Form.Group>
                    <Form.Control
                      type="text"
                      placeholder="Enter Banner Timer"
                      className={classNames("", {
                        "is-invalid": errors?.home_page_timer,
                      })}
                      {...register("home_page_timer", {
                        required: "Home Banner Timer is required",
                        validate: (value) => {
                          if (!/^\d+$/.test(value)) {
                            return "Only numbers are allowed";
                          }
                          if (Number(value) <= 0) {
                            return "Timer must be greater than 0";
                          }
                          return true;
                        },
                      })}
                      onKeyDown={(e) => {
                        if (
                          !(
                            e.key === "Backspace" ||
                            e.key === "Delete" ||
                            e.key === "Tab" ||
                            e.key === "ArrowLeft" ||
                            e.key === "ArrowRight" ||
                            (e.key >= "0" && e.key <= "9")
                          )
                        ) {
                          e.preventDefault();
                        }
                      }}
                    />
                    {errors.home_page_timer && (
                      <span className="text-danger">
                        {errors.home_page_timer.message}
                      </span>
                    )}
                  </Form.Group>
                </Row>
              </div>
            </Col>

            <Col md={12}>
              <div className="main-form-section mt-3">
                <Form.Group>
                  <div className="">
                    <Form.Label>Address</Form.Label>
                  </div>
                  <InputGroup>
                    <Form.Control
                      as="textarea"
                      name="address"
                      placeholder="Address"
                      className={classNames("", {
                        "is-invalid": errors?.address,
                      })}
                      {...register("address", {
                        required: "Address Is Required",
                        // validate: (value) =>
                        //   value.length <= 200 ||
                        //   "Data must be 200 characters or less",
                      })}
                    />
                  </InputGroup>
                  {errors.address && (
                    <span className="text-danger">
                      {errors.address.message}
                    </span>
                  )}
                </Form.Group>
              </div>
            </Col>

            {/* <Col md={12}>
              <div className="main-form-section mt-3">
                <Form.Group>
                  <div className="">
                    <Form.Label>Second Address</Form.Label>
                  </div>
                  <InputGroup>
                    <Form.Control
                      as="textarea"
                      name="address"
                      placeholder="Address"
                      className={classNames("", {
                        "is-invalid": errors?.second_address,
                      })}
                      {...register("second_address", {
                        required: "Address Is Required",
                        // validate: (value) =>
                        //   value.length <= 200 ||
                        //   "Data must be 200 characters or less",
                      })}
                    />
                  </InputGroup>
                  {errors.second_address && (
                    <span className="text-danger">
                      {errors.second_address.message}
                    </span>
                  )}
                </Form.Group>
              </div>
            </Col> */}

            <Col md={6}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-start">
                  <Form.Label className="text-left">Logo</Form.Label>

                  <Form.Group>
                    <Form.Control
                      className={classNames("", {
                        "is-invalid": errors?.logo,
                      })}
                      type="file"
                      {...register("logo", {
                        validate: (value) => {
                          // an existing logo (string) or no new file selected is fine
                          if (!value || typeof value === "string" || !value[0]) return true;
                          const fileTypes = ["jpg", "png", "jpeg", "webp"];
                          const fileType = value[0].name?.split(".").pop().toLowerCase();
                          if (!fileTypes.includes(fileType)) {
                            return `Please upload a valid file format. (${fileTypes.join(", ")})`;
                          }
                          if (Math.round(value[0].size / 1024) > 2048) {
                            return "File size must be lower than 2 MB";
                          }
                          return true;
                        },
                      })}
                      accept=".png,.jpg,.jpeg,.webp"
                    />
                  </Form.Group>
                  {errors.logo && (
                    <span className="text-danger">{errors.logo.message}</span>
                  )}
                  <Form.Group className="mt-3">
                    <Form.Label className="text-left">Logo Alt Tag</Form.Label>
                    <Form.Control
                      type="text"
                      name="logo_alt_tag"
                      placeholder="Logo Alt Tag"
                      {...register("logo_alt_tag")}
                    />
                  </Form.Group>
                </Row>
              </div>
            </Col>

            <Col lg={6}>
              <div className="main-form-section mt-3">
                <Form.Label>Logo Preview</Form.Label>

                {typeof getValues("logo") == "string" ? (
                  getValues("logo") && (
                    <div className="image-preview-container">
                      <img
                        src={IMG_URL + getValues("logo")}
                        alt="Preview"
                        className="image-preview"
                        onError={(e) => {
                          // the saved file is not an image: do not show a broken image
                          e.currentTarget.style.display = "none";
                        }}
                      />
                    </div>
                  )
                ) : (
                  imageFile &&
                  imageFile?.length > 0 && (
                    <div className="image-preview-container">
                      <img
                        src={URL?.createObjectURL(imageFile[0])}
                        alt="Preview"
                        className="image-preview"
                      />
                    </div>
                  )
                )}
              </div>
            </Col>

            <Col md={6}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-start">
                  <Form.Label className="text-left">Home Poster Image</Form.Label>

                  <Form.Group>
                    <Form.Control
                      className={classNames("", {
                        "is-invalid": errors?.home_poster_image,
                      })}
                      type="file"
                      {...register("home_poster_image", {
                        validate: (value) => {
                          // an existing image (string) or no new file selected is fine
                          if (!value || typeof value === "string" || !value[0]) return true;
                          const fileTypes = ["jpg", "png", "jpeg", "webp"];
                          const fileType = value[0].name?.split(".").pop().toLowerCase();
                          if (!fileTypes.includes(fileType)) {
                            return `Please upload a valid file format. (${fileTypes.join(", ")})`;
                          }
                          if (Math.round(value[0].size / 1024) > 2048) {
                            return "File size must be lower than 2 MB";
                          }
                          return true;
                        },
                      })}
                      accept=".png,.jpg,.jpeg,.webp"
                    />
                  </Form.Group>
                  {errors.home_poster_image && (
                    <span className="text-danger">
                      {errors.home_poster_image.message}
                    </span>
                  )}
                </Row>
              </div>
            </Col>

            <Col lg={6}>
              <div className="main-form-section mt-3">
                <Form.Label>Home Poster Image Preview</Form.Label>

                {typeof getValues("home_poster_image") == "string" ? (
                  getValues("home_poster_image") && (
                    <div className="image-preview-container">
                      <img
                        src={IMG_URL + getValues("home_poster_image")}
                        alt="Preview"
                        className="image-preview"
                        onError={(e) => {
                          // the saved file is not an image: do not show a broken image
                          e.currentTarget.style.display = "none";
                        }}
                      />
                    </div>
                  )
                ) : (
                  homePosterFile &&
                  homePosterFile?.length > 0 && (
                    <div className="image-preview-container">
                      <img
                        src={URL?.createObjectURL(homePosterFile[0])}
                        alt="Preview"
                        className="image-preview"
                      />
                    </div>
                  )
                )}
              </div>
            </Col>

            {/* <Col md={6}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-start">
                  <Form.Label className="text-left">QR Image</Form.Label>

                  <Form.Group>
                    <Form.Control
                      className={classNames("", {
                        "is-invalid": errors?.qr_image,
                      })}
                      type="file"
                      {...register("qr_image", {
                        // validate: async (value) => {
                        //   if (typeof value !== "string") {
                        //     const fileTypes = ["jpg", "png", "jpeg", "webp"];
                        //     const fileType = value[0].name?.split(".")[1];
                        //     if (!fileTypes.includes(fileType)) {
                        //       return `please upload a valid file format. (${fileTypes})`;
                        //     }
                        //     const sizes = await getDimension(value[0]);
                        //     if (
                        //       sizes.width !== 420 &&
                        //       sizes.height !== 520
                        //     ) {
                        //       return "Image width and height must be 420 px and 520 px";
                        //     }
                        //     const fileSize = Math.round(
                        //       value[0].size / 1024
                        //     );
                        //     if (fileSize > 500) {
                        //       return "file size must be lower than 500kb";
                        //     }
                        //   }
                        // },
                      })}
                      accept=".png"
                    />
                  </Form.Group>
                  {errors.qr_image && (
                    <span className="text-danger">
                      {errors.qr_image.message}
                    </span>
                  )}
                  <Form.Group className="mt-3">
                    <Form.Label className="text-left">QR Image Alt Tag</Form.Label>
                    <Form.Control
                      type="text"
                      name="qr_image_alt_tag"
                      placeholder="QR Image Alt Tag"
                      {...register("qr_image_alt_tag")}
                    />
                  </Form.Group>
                </Row>
              </div>
            </Col> */}

            {/* <Col lg={6}>
              <div className="main-form-section mt-3">
                <Form.Label>Image Preview</Form.Label>

                {typeof getValues("qr_image") == "string" ? (
                  <div className="image-preview-container">
                    <img
                      src={IMG_URL + getValues("qr_image")}
                      alt="Preview"
                      className="image-preview"
                    />
                  </div>
                ) : (
                  imageFileQR &&
                  imageFileQR?.length > 0 && (
                    <div className="image-preview-container">
                      <img
                        // src={URL.createObjectURL(getValues("image")[0])}
                        src={URL?.createObjectURL(imageFileQR[0])}
                        alt="Preview"
                        className="image-preview"
                      />
                    </div>
                  )
                )}
              </div>
            </Col> */}

            <Col md={6}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-start">
                  <Form.Label className="text-left">
                    Common EJS / PDF Document
                  </Form.Label>

                  <Form.Group>
                    <Form.Control
                      className={classNames("", {
                        "is-invalid": errors?.common_ejs,
                      })}
                      type="file"
                      accept=".pdf,.doc,.docx,.ejs"
                      {...register("common_ejs", {
                        validate: (value) => {
                          const hasExistingFile = !!existingCommonEjs;

                          // 🔥 FIX: detect real file upload properly
                          const hasNewFile =
                            value && value?.[0] instanceof File;

                          // Case 1: existing file, no new upload
                          if (hasExistingFile && !hasNewFile) return true;

                          // Case 2: new file uploaded
                          if (hasNewFile) {
                            const file = value[0];

                            const allowedTypes = ["pdf", "doc", "docx", "ejs"];
                            const extension = file?.name
                              ?.split(".")
                              .pop()
                              ?.toLowerCase();

                            if (!allowedTypes.includes(extension)) {
                              return "Only PDF, DOC, DOCX and EJS files are allowed";
                            }

                            const fileSize = Math.round(file.size / 1024);

                            if (fileSize > 5000) {
                              return "File size must be less than 5MB";
                            }
                          }

                          return true;
                        },
                      })}
                    />
                  </Form.Group>

                  {errors.common_ejs && (
                    <span className="text-danger">
                      {errors.common_ejs.message}
                    </span>
                  )}
                </Row>
              </div>
            </Col>

            <Col lg={6}>
              <div className="main-form-section mt-3">
                <Form.Label>Document Preview</Form.Label>

                {/* Existing File Preview */}
                {typeof getValues("common_ejs") === "string" ? (
                  <div>
                    {getValues("common_ejs")?.endsWith(".pdf") ? (
                      <iframe
                        src={IMG_URL + getValues("common_ejs")}
                        title="PDF Preview"
                        width="100%"
                        height="400px"
                      />
                    ) : (
                      <a
                        href={IMG_URL + getValues("common_ejs")}
                        target="_blank"
                        rel="noreferrer"
                      >
                        View Uploaded Document
                      </a>
                    )}
                  </div>
                ) : (
                  commonEjsFile &&
                  commonEjsFile?.length > 0 && (
                    <div>
                      {commonEjsFile[0]?.type === "application/pdf" ? (
                        <iframe
                          src={URL.createObjectURL(commonEjsFile[0])}
                          title="PDF Preview"
                          width="100%"
                          height="400px"
                        />
                      ) : (
                        <a
                          href={URL.createObjectURL(commonEjsFile[0])}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Preview Selected File
                        </a>
                      )}
                    </div>
                  )
                )}
              </div>
            </Col>

            <Col md={6}>
              <div className="main-form-section mt-3">
                <Form.Group>
                  <div className="">
                    <Form.Label>Meta Title</Form.Label>
                  </div>
                  <InputGroup>
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="Meta Title"
                      className={classNames("", {
                        "is-invalid": errors?.meta_title,
                      })}
                      {...register("meta_title", {
                        required: "Meta title is required",
                      })}
                    />
                  </InputGroup>
                  {errors.meta_title && (
                    <span className="text-danger">
                      {errors.meta_title.message}
                    </span>
                  )}
                </Form.Group>
              </div>
            </Col>

            <Col md={6}>
              <div className="main-form-section mt-3">
                <Form.Group>
                  <div className="">
                    <Form.Label>Meta Description</Form.Label>
                  </div>
                  <InputGroup>
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="Meta Description"
                      className={classNames("", {
                        "is-invalid": errors?.meta_description,
                      })}
                      {...register("meta_description", {
                        required: "Meta Description is required",
                      })}
                    />
                  </InputGroup>
                  {errors.meta_description && (
                    <span className="text-danger">
                      {errors.meta_description.message}
                    </span>
                  )}
                </Form.Group>
              </div>
            </Col>

            <Col md={6}>
              <div className="main-form-section mt-3">
                <Form.Group>
                  <div className="">
                    <Form.Label>Meta Keywords</Form.Label>
                  </div>
                  <InputGroup>
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="Meta Keywords"
                      className={classNames("", {
                        "is-invalid": errors?.keywords,
                      })}
                      {...register("keywords", {
                        required: "Meta Keywords is required",
                      })}
                    />
                  </InputGroup>
                  {errors.keywords && (
                    <span className="text-danger">
                      {errors.keywords.message}
                    </span>
                  )}
                </Form.Group>
              </div>
            </Col>

            <Col md={6}>
              <div className="main-form-section mt-3">
                <Form.Group>
                  <div className="">
                    <Form.Label>Schema Data</Form.Label>
                  </div>
                  <InputGroup>
                    <Form.Control
                      as="textarea"
                      rows={5}
                      name="name"
                      placeholder="Schema Data"
                      className={classNames("", {
                        "is-invalid": errors?.schema_data,
                      })}
                      {...register("schema_data", {
                        required: "Schema Data is required",
                      })}
                    />
                  </InputGroup>
                  {errors.schema_data && (
                    <span className="text-danger">
                      {errors.schema_data.message}
                    </span>
                  )}
                </Form.Group>
              </div>
            </Col>

            <Row className="mt-5 pb-3">
              <div className="d-flex justify-content-center">
                <Link to={"/settings/app-setup"}>
                  <CancelButton
                    name={"cancel"}
                    handleClose={props.handleClose}
                  />
                </Link>

                <SaveButton
                  name={"save"}
                  handleSubmit={handleSubmit(onSubmit)}
                />
                {/* <SaveButton name={"save"} type="submit" /> */}
              </div>
            </Row>
          </Row>
        </Form>
      </section>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
